import React from 'react';

export const DuringEngineerVisitAccordion: React.FC = () => (
  <ul>
    <li>
      <h5>Clear a space where you want your equipment installed.</h5>
    </li>
    <li>
      <h5>
        Make sure there are no hazards on site or access restrictions that could stop the engineer from completing their
        work.
      </h5>
    </li>
    <li>
      <h5>Give the engineer access to anywhere they need to work.</h5>
    </li>
    <li>
      <h5>The engineer will carry out the work needed to install your equipment. </h5>
      For example they may need to drill holes for a cable to access your property or to secure ladders to your external
      walls.
    </li>
    <li>
      <h5>The engineer will run tests to make sure everything’s working properly. </h5>
      We’ll use one of your devices to check your new connection.
    </li>
  </ul>
);
